"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentenceEnv = exports.isSentenceLike = exports.sentenceLikeTags = exports.setTextControl = exports.textOfSentenceText = exports.isSentenceText = exports.sentenceTextTags = exports.toSentenceTextRanges = void 0;
exports.enumerateSentenceTexts = enumerateSentenceTexts;
const _1 = require(".");
const common_1 = require("../../analyzer/common");
const std = __importStar(require("../../law/std"));
const util_1 = require("../../parser/cst/util");
const controls_1 = require("../el/controls");
const pushRange = (ranges, ...rangesToAdd) => {
    for (const range of rangesToAdd) {
        if (ranges.length === 0) {
            ranges.push(range);
        }
        else {
            const lastRange = ranges[ranges.length - 1];
            if (lastRange.end.sentenceIndex === range.start.sentenceIndex && lastRange.end.textOffset === range.start.textOffset) {
                lastRange.end = range.end;
            }
            else {
                ranges.push(range);
            }
        }
    }
};
const fromToContainersToTextRanges = (from, to, sentenceEnvsStruct) => {
    const ranges = [];
    if (to) {
        const fromContainer = sentenceEnvsStruct.containers.get(from);
        const toContainer = sentenceEnvsStruct.containers.get(to);
        if (fromContainer && toContainer) {
            pushRange(ranges, {
                start: {
                    sentenceIndex: fromContainer.sentenceRange[0],
                    textOffset: 0,
                },
                end: {
                    sentenceIndex: toContainer.sentenceRange[1],
                    textOffset: 0,
                },
            });
        }
    }
    else {
        const container = sentenceEnvsStruct.containers.get(from);
        if (container) {
            if (container.type === _1.ContainerType.ROOT) {
                // "この法律" does not contain SupplProvision of other amendments.
                for (const rootChild of container.children) {
                    if (std.isSupplProvision(rootChild.el) && rootChild.el.attr.AmendLawNum) {
                        continue;
                    }
                    pushRange(ranges, {
                        start: {
                            sentenceIndex: rootChild.sentenceRange[0],
                            textOffset: 0,
                        },
                        end: {
                            sentenceIndex: rootChild.sentenceRange[1],
                            textOffset: 0,
                        },
                    });
                }
            }
            else {
                pushRange(ranges, {
                    start: {
                        sentenceIndex: container.sentenceRange[0],
                        textOffset: 0,
                    },
                    end: {
                        sentenceIndex: container.sentenceRange[1],
                        textOffset: 0,
                    },
                });
            }
        }
    }
    return ranges;
};
const excludeTextRanges = (origRanges, excludeRanges) => {
    if (origRanges.length === 0 || excludeRanges.length === 0)
        return origRanges;
    const ranges = [...origRanges.map(r => ({ ...{ start: { ...r.start }, end: { ...r.end } } }))];
    for (const excludeRange of excludeRanges) {
        for (let i = 0; i < ranges.length; i++) {
            const range = ranges[i];
            if ((range.end.sentenceIndex < excludeRange.start.sentenceIndex)
                || ((range.end.sentenceIndex === excludeRange.start.sentenceIndex)
                    && (range.end.textOffset < excludeRange.start.textOffset))
                || (excludeRange.end.sentenceIndex < range.start.sentenceIndex)
                || ((excludeRange.end.sentenceIndex === range.start.sentenceIndex)
                    && (excludeRange.end.textOffset < range.start.textOffset))) {
                // No overlapping
                continue;
            }
            else if ((range.start.sentenceIndex < excludeRange.end.sentenceIndex)
                || ((range.start.sentenceIndex === excludeRange.end.sentenceIndex)
                    && (range.start.textOffset <= excludeRange.end.textOffset))) {
                if ((range.end.sentenceIndex < excludeRange.end.sentenceIndex)
                    || ((range.end.sentenceIndex === excludeRange.end.sentenceIndex)
                        && (range.end.textOffset <= excludeRange.end.textOffset))) {
                    // End of range will be excluded
                    range.end = { ...excludeRange.start };
                }
                else {
                    // Middle of range will be excluded
                    ranges.splice(i + 1, 0, {
                        start: { ...excludeRange.end },
                        end: { ...range.end },
                    });
                    range.end = { ...excludeRange.start };
                    i++;
                }
            }
            else {
                if ((range.end.sentenceIndex < excludeRange.end.sentenceIndex)
                    || ((range.end.sentenceIndex === excludeRange.end.sentenceIndex)
                        && (range.end.textOffset <= excludeRange.end.textOffset))) {
                    // Whole range will be excluded
                    ranges.splice(i, 1);
                    i--;
                }
                else {
                    // Start of range will be excluded
                    range.start = { ...excludeRange.end };
                }
            }
        }
    }
    return ranges;
};
const toSentenceTextRanges = (origRangeInfos, sentenceEnvsStruct, following) => {
    if (origRangeInfos) {
        const rangesBeforeFollowing = [];
        for (const rangeInfo of origRangeInfos) {
            const { from, to } = rangeInfo;
            const origRanges = fromToContainersToTextRanges(from, to ?? null, sentenceEnvsStruct);
            const excludeRanges = rangeInfo.exclude && (0, exports.toSentenceTextRanges)(rangeInfo.exclude, sentenceEnvsStruct);
            if (excludeRanges) {
                pushRange(rangesBeforeFollowing, ...excludeTextRanges(origRanges, excludeRanges));
            }
            else {
                pushRange(rangesBeforeFollowing, ...origRanges);
            }
        }
        if (following) {
            const ranges = [];
            for (const origRange of rangesBeforeFollowing) {
                if (origRange.end.sentenceIndex === following.sentenceIndex) {
                    if (origRange.end.textOffset < following.textOffset) {
                        continue;
                    }
                }
                else if (origRange.end.sentenceIndex < following.sentenceIndex) {
                    continue;
                }
                const range = { start: { ...origRange.start }, end: { ...origRange.end } };
                if (range.start.sentenceIndex === following.sentenceIndex) {
                    if (range.start.textOffset < following.textOffset) {
                        Object.assign(range.start, following);
                    }
                }
                else if (range.start.sentenceIndex < following.sentenceIndex) {
                    Object.assign(range.start, following);
                }
                pushRange(ranges, range);
            }
            return ranges;
        }
        else {
            return rangesBeforeFollowing;
        }
    }
    else {
        if (!following)
            return [];
        // const sentenceEnv = sentenceEnvsStruct.sentenceEnvs[following.sentenceIndex];
        const start = { ...following };
        // const topLevelContainer = sentenceEnv.container.thisOrClosest(p => p.type === ContainerType.TOPLEVEL) ?? sentenceEnvsStruct.rootContainer;
        const ranges = [];
        pushRange(ranges, {
            start,
            end: {
                sentenceIndex: sentenceEnvsStruct.rootContainer.sentenceRange[1],
                textOffset: 0,
            },
        });
        // if (std.isMainProvision(topLevelContainer.el)) {
        //     const originalSupplProvisions = topLevelContainer.parent?.children.filter(c => (std.isSupplProvision(c.el) && (!c.el.attr.AmendLawNum))) ?? [];
        //     pushRange(
        //         ranges,
        //         {
        //             start,
        //             end: {
        //                 sentenceIndex: topLevelContainer.sentenceRange[1],
        //                 textOffset: 0,
        //             },
        //         },
        //         ...originalSupplProvisions.map(c => ({
        //             start: {
        //                 sentenceIndex: c.sentenceRange[0],
        //                 textOffset: 0,
        //             },
        //             end: {
        //                 sentenceIndex: c.sentenceRange[1],
        //                 textOffset: 0,
        //             },
        //         })),
        //     );
        // } else {
        //     pushRange(
        //         ranges,
        //         {
        //             start,
        //             end: {
        //                 sentenceIndex: topLevelContainer.sentenceRange[1],
        //                 textOffset: 0,
        //             },
        //         },
        //     );
        // }
        return ranges;
    }
};
exports.toSentenceTextRanges = toSentenceTextRanges;
exports.sentenceTextTags = [
    "Ruby",
    "QuoteStruct",
    "ArithFormula",
    "Sub",
    "Sup",
    "Line",
    "__Text",
    "__PStart",
    "__PEnd",
    "__MismatchStartParenthesis",
    "__MismatchEndParenthesis",
    "____Pointer",
    "____LawNum",
    "____Declaration",
    "____VarRef",
];
const isSentenceText = (el) => typeof el !== "string" && exports.sentenceTextTags.includes(el.tag);
exports.isSentenceText = isSentenceText;
const textOfSentenceText = (el) => {
    if (el.tag === "Ruby") {
        return el.children.map(c => {
            if (typeof c === "string") {
                return c;
            }
            else if (c instanceof controls_1.__Text) {
                return c.text();
            }
            else {
                return "";
            }
        }).join("");
    }
    else {
        return el.text();
    }
};
exports.textOfSentenceText = textOfSentenceText;
function* enumerateSentenceTexts(el) {
    if ((0, exports.isSentenceText)(el)) {
        yield el;
    }
    else if (!(0, common_1.isIgnoreAnalysis)(el)) {
        for (const child of el.children) {
            if (typeof child === "string")
                continue;
            yield* enumerateSentenceTexts(child);
        }
    }
}
const setTextControl = (el) => {
    if ((0, exports.isSentenceLike)(el) && el.children.some(c => typeof c === "string")) {
        const first = el.children[0];
        if (typeof first === "string") {
            el.children[0] = new controls_1.__Text(first, el.range && [el.range[0], el.range[0] + first.length]);
        }
        el.children.splice(0, el.children.length, ...(0, util_1.mergeAdjacentTextsWithString)(el.children));
    }
    for (const child of el.children) {
        if (typeof child === "string" || (0, exports.isSentenceText)(child))
            continue;
        (0, exports.setTextControl)(child);
    }
};
exports.setTextControl = setTextControl;
exports.sentenceLikeTags = ["Sentence", "EnactStatement", "TableHeaderColumn"];
const isSentenceLike = (el) => typeof el !== "string" && exports.sentenceLikeTags.includes(el.tag);
exports.isSentenceLike = isSentenceLike;
class SentenceEnv {
    index;
    el;
    lawType;
    parentELs;
    container;
    _text;
    get text() { return this._text; }
    _pointerLikes = [];
    get pointerLikes() {
        return this._pointerLikes;
    }
    addPointerLike(pointerLike) {
        if (pointerLike.textRange) {
            for (let i = this._pointerLikes.length - 1; 0 <= i; i--) {
                const iRange = this._pointerLikes[i].textRange;
                if (iRange && iRange[0] < pointerLike.textRange[0]) {
                    this._pointerLikes.splice(i + 1, 0, pointerLike);
                    return;
                }
            }
            this._pointerLikes.unshift(pointerLike);
        }
        else {
            this._pointerLikes.push(pointerLike);
        }
    }
    constructor(options) {
        const { index, elToBeModified: el, lawType, parentELs, container } = options;
        this.index = index;
        this.el = el;
        this.lawType = lawType;
        this.parentELs = parentELs;
        this.container = container;
        (0, exports.setTextControl)(el);
        this._text = [...enumerateSentenceTexts(el)].map(exports.textOfSentenceText).join("");
        const setParentOfChildELs = (el) => {
            for (const c of el.children) {
                if (typeof c === "string")
                    continue;
                setParentOfChildELs(c);
            }
        };
        setParentOfChildELs(this.el);
    }
    linealAscendantOfEL(el) {
        const f = (current, el) => {
            if (current === el)
                return [current];
            for (const child of current.children) {
                if (typeof child === "string")
                    continue;
                const result = f(child, el);
                if (result)
                    return [current, ...result];
            }
            return null;
        };
        return f(this.el, el);
    }
    textRageOfEL(el) {
        if ((0, exports.isSentenceText)(el)) {
            let offset = 0;
            for (const sentenceText of enumerateSentenceTexts(this.el)) {
                const length = (0, exports.textOfSentenceText)(sentenceText).length;
                if (sentenceText === el) {
                    return [offset, offset + length];
                }
                offset += length;
            }
            return null;
        }
        else {
            const targetSentenceTexts = [...enumerateSentenceTexts(el)];
            const firstTarget = targetSentenceTexts[0];
            const lastTarget = targetSentenceTexts[targetSentenceTexts.length - 1];
            let offset = 0;
            let start = null;
            for (const sentenceText of enumerateSentenceTexts(this.el)) {
                const length = (0, exports.textOfSentenceText)(sentenceText).length;
                if (sentenceText === firstTarget) {
                    start = offset;
                }
                if (sentenceText === lastTarget) {
                    return ((start !== null) && [start, offset + length]) || null;
                }
                offset += length;
            }
            return null;
        }
    }
    sentenceTextAt(targetOffset) {
        let offset = 0;
        for (const sentenceText of enumerateSentenceTexts(this.el)) {
            const length = (0, exports.textOfSentenceText)(sentenceText).length;
            if (offset <= targetOffset && targetOffset < offset + length) {
                return sentenceText;
            }
            offset += length;
        }
        return null;
    }
}
exports.SentenceEnv = SentenceEnv;
//# sourceMappingURL=sentenceEnv.js.map